// Chat constants and configuration
export const CHAT_CONFIG = {
  PAGE_SIZE: 20,
  TYPING_SPEED: 30, // milliseconds per character
  RESPONSE_DELAY: 1000, // milliseconds
  VOICE_AUTO_SEND_DELAY: 500, // milliseconds
  SCROLL_MAINTAIN_DELAY: 100, // milliseconds
} as const;

export const QUICK_ACTIONS = [
  { 
    id: 'orders', 
    label: 'Nhập hàng', 
    icon: 'shopping-cart', 
    action: 'Gợi ý nhập hàng cho cửa hàng nhé!' 
  },
  { 
    id: 'missions', 
    label: 'Nhiệm vụ', 
    icon: 'target', 
    action: 'Có nhiệm vụ tích điểm nhận quà nào phù hợp cho cửa hàng không?' 
  },
  { 
    id: 'promotions', 
    label: 'Khuyến mãi', 
    icon: 'gift', 
    action: 'Có khuyến mãi nào đang áp dụng cho cửa hàng không?' 
  }
] as const;

// Error messages will be handled in the API error handling instead

export const SPEECH_CONFIG = {
  LANG: 'vi-VN',
  CONTINUOUS: false,
  INTERIM_RESULTS: false,
} as const;

export const MESSAGE_LIMITS = {
  MAX_LENGTH: 500,
  WARNING_LENGTH: 400,
} as const;
